// extracted by mini-css-extract-plugin
export default {"block":"GridHeader_block__zoHQU","item":"GridHeader_item__3aoNa"};